










/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'IfpFilterWatching',

  methods: {
    handleCloseClick() {
      this.$emit('only-watching-updated', false)
    },
  },
})
